import { useParams } from 'next/navigation';

import { useProductBySlugBasic } from './useProductBySlugBasic';

export function useProductBySlugBasicPDP() {
  const { slug } = useParams<{ slug: string }>();
  return useProductBySlugBasic(slug);
}
